
import { FAQSchema } from "@/components/seo/FAQSchema";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqItems: FAQItem[];
}

export const FAQSection = ({ faqItems }: FAQSectionProps) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-12 text-center text-edgefi-black">
            Frequently Asked Questions
          </h2>

          <FAQSchema items={faqItems} />

          <div className="space-y-6">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-sm p-6 border border-gray-100"
              >
                <h3 className="font-semibold text-xl text-edgefi-purple mb-3">
                  {item.question}
                </h3>
                <div className="prose prose-sm max-w-none text-gray-600">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-gray-600 mb-4">
              Have more questions about Microsoft 365 Security?
            </p>
            <a
              href="/get-started"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-edgefi-purple hover:bg-edgefi-amethyst transition duration-150"
            >
              Contact Our Experts
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
